<template>
  <div v-if="!isLoading">
    <div style="max-width: 28rem;">
      <h2 class="h6 _text(300) _text-grey-900 _m:bottom(4)">{{ $t('view.SignIn.forms.info.title') }}:</h2>
      <div class="_text:reg _text(500) _m:y(2)">
        {{$t('view.SignUp.labels.investorType')}}
      </div>
      <ds ds="form"
        id="info"
        @valid="e => isValid = e.detail"
        @submit="saveInfo"
      >
        <ds ds="input-radio"
          name="investorType"
          :value.sync="investorType"
          checkedValue="individual"
          :label="$t('view.SignUp.labels.investorTypePhysical')"
          :validate="ds.vString"
          :isDisabled="this.individualDisabled"
        />
        <ds ds="input-radio"
          name="investorType"
          :value.sync="investorType"
          checkedValue="institution"
          :label="$t('view.SignUp.labels.investorTypeLegal')"
          :validate="ds.vString"
          :class="'_m:bottom(3)'"
          :isDisabled="this.institutionDisabled"
        />

        <div class="_text:reg _text(500) _m:y(2)">
          {{$t('view.SignUp.labels.countrySelect')}}
        </div>
        <ds ds="select-country"
          name="country"
          :value.sync="country"
          returnType="alpha3"
          :label="$t('view.SignUp.labels.country')"
          :isRequired="true"
          class="_m:bottom(4)"
        />
        <ds ds="button"
          :label="$t('shared.action.continue')"
          version="primary"
          icon="arrow-right"
          type="submit"
          class="_m:bottom(3)"
        />
        <ds
          ds="button"
          :label="$t('shared.action.signOut')"
          mode="text"
          @click="this.signOut"
          class="auth-footer"
        />

      </ds>
    </div>
  </div>
  <Loader v-else/>
</template>

<script>
import { eventBus } from '@/eventBus';
import { mapGetters, mapActions } from 'vuex';
import { LoggerService } from '@/services';
import { authHelper } from '@/mixins';
import { Loader } from '@/components';
export default {
  name: 'Info',
  mixins: [authHelper],
  components: { Loader },
  data: () => ({
    isLoading: true,
    isValid: false,
    investorType: null,
    country: null
  }),
  computed: {
    ...mapGetters({
      signUpInfo: 'qualification/signUpInfo',
      userEmail: 'qualification/userEmail',
      investorAllowed: 'qualification/investorAllowed',
      investorTypes: 'qualification/investorTypes',
      locale: 'locale/locale'
    }),
    windowTitle () {
      return this.$t('view.SignIn.title');
    },
    individualDisabled () {
      return this.investorTypes && !this.investorTypes.includes('individual');
    },
    institutionDisabled () {
      return this.investorTypes && !this.investorTypes.includes('institution');
    }
  },
  methods: {
    ...mapActions({
      fetchInvestorTypes: 'qualification/fetchInvestorTypes',
      fetchInvestorAllowed: 'qualification/fetchInvestorAllowed',
      newInvestor: 'qualification/newInvestor',
      investorLanguage: 'qualification/investorLanguage'
    }),
    async saveInfo () {
      eventBus.$emit('isSubmitting', true);
      try {
        await this.newInvestor({ country: this.country, investorType: this.investorType });
        await this.investorLanguage(this.locale);
        await this.fetchInvestorAllowed();
      } catch (error) {
        LoggerService.error(error);
        await this.signOut();
      }
      eventBus.$emit('isSubmitting', false);
      this.$router.push({ name: 'appIndex' });
    }
  },
  watch: {
    isLoggedIn () {
      if (!this.isLoggedIn) {
        this.$router.replace({ name: 'sign-in' });
      }
    }
  },
  async mounted () {
    if (this.investorAllowed !== 'ERROR_IDENTITY_NOT_COMPLETE') {
      this.$router.replace({ name: 'appIndex' });
      return;
    }

    try {
      await this.fetchInvestorTypes();
      if (this.individualDisabled) this.investorType = 'institution';
      if (this.institutionDisabled) this.investorType = 'individual';
    } catch (error) {
      LoggerService.error(error);
    }

    // email is not null and should match
    if (this.signUpInfo.email && this.signUpInfo.email === this.userEmail) {
      this.investorType = this.signUpInfo.investorType;
      this.country = this.signUpInfo.country;
      await this.saveInfo();
      return;
    }
    this.isLoading = false;
  }
};
</script>
